import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'src/hooks';
import { AttendeeTicket } from 'src/types/types';
import { Text } from 'src/redesign/components/Text';
import { RedesignButton } from 'src/redesign/components/RedesignButton';
import { Ticket, Send } from 'lucide-react';
import { closeAttendeeTicketsModal, resetHelpBubble } from '../store/reducer';
import { setCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { CONNECTED_MODALS } from 'src/redesign/features/Modals/store/constants';
import moment from 'moment';
import styles from './TicketCard.module.scss';

interface TicketCardProps {
  ticket: AttendeeTicket;
}

export const TicketCard = ({ ticket }: TicketCardProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const handleViewTicket = () => {
    dispatch(closeAttendeeTicketsModal());
    dispatch(resetHelpBubble());
    history.push(`/attendee-dashboard/ticket/${ticket.cart_id}`);
  };

  const handleContactHost = () => {
    dispatch(closeAttendeeTicketsModal());
    dispatch(resetHelpBubble());
    dispatch(
      setCurrentModalAction({
        currentModal: CONNECTED_MODALS.CONTACT_HOST_MODAL,
        data: {
          title: 'Contact Host',
          ticketInfo: ticket,
        },
      }),
    );
  };

  // Format date
  const formattedDate =
    ticket.event.formatted_date || moment(ticket.event.start_date).format('MMM DD, YYYY');

  return (
    <div className={styles.ticketCard}>
      {ticket.event.image_url && (
        <img src={ticket.event.image_url} alt={ticket.event.title} className={styles.thumbnail} />
      )}

      <div className={styles.eventInfo}>
        <Text variation="body" bold className={styles.title}>
          {ticket.event.title}
        </Text>
        <Text variation="body-small" color="black-400" className={styles.date}>
          {formattedDate}
        </Text>
        {ticket.event.location && (
          <Text variation="body-small" color="black-400" className={styles.location}>
            {ticket.event.location}
          </Text>
        )}
      </div>

      <div className={styles.actions}>
        <RedesignButton
          variation="primary"
          height={40}
          onClick={handleViewTicket}
          className={styles.actionButton}
        >
          <Ticket size={16} />
          <Text variation="body-small" color="white-100">
            View Ticket
          </Text>
        </RedesignButton>

        <RedesignButton
          variation="secondary"
          height={40}
          onClick={handleContactHost}
          className={styles.actionButton}
        >
          <Send size={16} />
          <Text variation="body-small" color="brand-400">
            Contact Host
          </Text>
        </RedesignButton>
      </div>
    </div>
  );
};
